<template>
  <div class="table-list">
    <div class="table-wrap" v-for="(table, table_index) in tableData" :key="table_index">
      <div class="table-item">
        <div class="table-row" v-for="(row, row_index) in table" :key="row_index">
          <span
            :class="col.link != '' ? 'link' : ''"
            v-for="(col, col_index) in row"
            :key="col_index"
          >
            {{ col.name }}
            <span
              v-if="row_index == 0"
              @click="handleShowDialog(table_index, col_index, table)"
              class="slide-down"
            >
              <a-icon type="caret-down" />
            </span>
          </span>
        </div>
      </div>
    </div>
    <a-modal
      title="采集数据"
      :bodyStyle="{ padding: '5px 20px 20px' }"
      :visible="visible"
      :footer="null"
      @cancel="handleCancel"
    >
      <a-tabs @change="handleTabClick">
        <a-tab-pane key="1" tab="采集列表">
          <a-checkbox-group v-model="selectList" @change="onChange">
            <div class="check-list">
              <div class="check-item" v-for="(item, index) in loadList" :key="index">
                <a-checkbox :value="item.link" style="display: block;width: 100%">
                  {{ item.name }}
                </a-checkbox>
              </div>
            </div>
          </a-checkbox-group>
          <div class="collect-btn">
            <a-button type="primary" @click="handleBeginCollect"> 立即采集 </a-button>
          </div>
        </a-tab-pane>
        <a-tab-pane key="process" tab="采集进度">
          <ul class="process">
            <li v-for="item in processs" :key="item.url">
              <em class="wait" v-if="item.status == 0">等待爬取</em>
              <em class="processing" v-if="item.status == 1">正在爬取</em>
              <em class="success" v-if="item.status == 2">爬取成功</em>
              <em class="failure" v-if="item.status == -1">爬取失败</em>
              <span>{{ urlToNameMap[item.url] }}</span>
            </li>
          </ul>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>

<script>
import { queryCollectDetaileByIdApi, queryByIdsOrUrlsApi } from '@/api/TopicCrawl/ColectInfo'
import { addSubjectContentApi } from '@/api/TopicCrawl/CollectList'
export default {
  data() {
    return {
      tableData: [],
      checkedList: [],
      visible: false,
      loadMap: {},
      urlToNameMap: {},
      loadList: [],
      selectList: [],
      subjectId: '',
      subjectContentId: '',
      key: '',
      processs: []
    }
  },
  created() {
    let { subjectId, subjectContentId, type } = this.$route.query
    this.subjectId = subjectId
    this.subjectContentId = subjectContentId
    this.type = type
    this.queryCollectDetaileById()
  },
  methods: {
    getPostData() {
      let postData = this.selectList.map((item) => {
        return {
          url: item,
          type: this.type
        }
      })
      return postData
    },
    async handleBeginCollect() {
      const res = await addSubjectContentApi(
        { subjectId: this.subjectId, subjectContentId: this.subjectContentId },
        this.getPostData()
      )
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    async queryByIdsOrUrlsApi() {
      const res = await queryByIdsOrUrlsApi({ queryType: 'url' }, this.selectList)
      const { code, msg, data } = res
      if (code == '200') {
        this.processs = data
      } else {
        this.$message.error(msg)
      }
    },

    handleTabClick(val) {
      if (val == 'process') {
        this.queryByIdsOrUrlsApi()
      }
    },

    async queryCollectDetaileById() {
      let { subjectContentId } = this.$route.query
      let res = await queryCollectDetaileByIdApi({ subjectContentId })
      let { code, msg, extra } = res
      if (code == '200') {
        this.tableData = extra.content.table_info
      } else {
        this.$message.error(msg)
      }
    },
    handleShowDialog(table_index, col_index, table) {
      let key = table_index + '_' + col_index
      this.key = key
      if (!this.loadMap[key]) {
        let result = []
        let data = table.slice(1)
        data.forEach((item) => {
          result.push(item[col_index])
        })
        let downLoadData = []
        result.forEach((item) => {
          if (item.link != '') {
            downLoadData.push(item)
          }
        })
        this.loadMap[key] = {
          select: [],
          lists: JSON.parse(JSON.stringify(downLoadData))
        }
      }
      this.loadList = this.loadMap[key].lists
      this.urlToNameMap = {}
      for (let item of this.loadList) {
        this.urlToNameMap[item.link] = item.name
      }
      this.selectList = this.loadMap[key].select
      this.visible = true
    },
    onChange(val) {
      this.loadMap[this.key].select = JSON.parse(JSON.stringify(val))
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.table-list {
  height: 100%;
  padding: 16px;
  .table-wrap {
    padding: 16px;
    background: #fff;
    margin-bottom: 20px;
    .table-item {
      border: 1px solid #e2e2e2;
      border-radius: 2px;
      .table-row {
        display: flex;
        border-bottom: 1px solid #e2e2e2;
        &:first-child {
          background: #f2f6fb;
        }
        &:last-child {
          border-bottom: none;
        }
        span {
          display: flex;
          align-items: center;
          flex: 1;
          min-height: 44px;
          vertical-align: middle;
          padding: 5px 10px;
          border-right: 1px solid #e2e2e2;
          position: relative;
          &.link {
            color: #40a9ff;
            font-weight: 600;
          }
          .slide-down {
            position: absolute;
            right: 10px;
            color: #40a9ff;
            font-size: 20px;
            cursor: pointer;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
}
.check-list {
  width: 300px;
  display: flex;
  flex-wrap: wrap;
  .check-item {
    /*flex: 0 0 80%;*/
    display: block;
    width: 300px;
    line-height: 30px;
  }
}
.collect-btn {
  padding: 10px 0px 0;
}
.process {
  li {
    line-height: 20px;
    margin-bottom: 10px;
    display: flex;
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    align-items: center;
    span {
      flex: 1;
    }
    em {
      padding: 3px 5px;
      width: 100px;
      margin-right: 10px;
      border-radius: 2px;
      font-style: normal;
      background: chocolate;
      text-align: center;
      &.processing {
        background: #f0faef;
        border: 1px solid #66c25d;
      }
      &.wait {
        background: #f0faef;
        border: 1px solid #40a9ff;
      }
      &.success {
        background: #fff6e2;
        border: 1px solid #ffc852;
      }
      &.failure {
        background: #fff2f2;
        border: 1px solid #fd7171;
      }
    }
  }
}
</style>
